// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_-Jj","cls2":"FocusedNav-cls2_Ljd FocusedNav-cls1_-Jj"};